import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="data-exports--definition-list"
export default class extends Controller {
  static targets = ["search", "item"]

  filter() {
    const q = this.searchTarget.value.trim().toLowerCase()

    this.itemTargets.forEach((item) => {
      const text = (item.dataset.search || "").toLowerCase()
      item.classList.toggle("hidden", q !== "" && !text.includes(q))
    })
  }
}
